import { getDeudoresExpensas, getResumenExpensas, getDetalleGastos, getExpensasPDF } from "../service/DashboardService";

const formatDateForAPI = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const fetchLiquidacionPdfData = async (barrioId, administracionId, selectedDate) => {
    const periodoStr = formatDateForAPI(selectedDate);
    const [deudoresRes, resumenRes, detalleGastosRes, expensasRes] = await Promise.all([
        getDeudoresExpensas(barrioId, administracionId, selectedDate),
        getResumenExpensas(barrioId, administracionId, selectedDate),
        getDetalleGastos(barrioId, administracionId, selectedDate),
        getExpensasPDF(barrioId, administracionId, periodoStr),
    ]);

    return {
        deudores: deudoresRes.data,
        resumen: resumenRes.data,
        detalleGastos: detalleGastosRes.data,
        expensas: expensasRes.data,
    };
};

export const generarPdfBase64 = async (node) => {
    const html2pdf = (await import('html2pdf.js')).default;
    const htmlContent = node.outerHTML;

    const dataUri = await html2pdf()
        .set({
            margin: 0,
            filename: 'liquidacion.pdf',
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, logging: false },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        })
        .from(htmlContent)
        .outputPdf('datauristring');

    return dataUri.split(',')[1];
};
